import { RelationshipUtils } from '../relationship/relationship-utils';
import { fieldName } from './fieldName';
import { fieldType } from './fieldType';

function properties(field, rootGetters) {
  if (!field.properties) {
    return [];
  }

  const label = rootGetters['builder/fieldProperty/label'];
  const value =
    rootGetters['builder/fieldProperty/displayableValue'];

  return Object.keys(field.properties).map((key) => {
    return `${label(field, key)}: ${value(
      field,
      key,
      field.properties[key],
    )}`;
  });
}

function relation(field, rootGetters) {
  if (!field.relation) {
    return [];
  }

  const label = rootGetters['builder/fieldRelation/label'];
  const value =
    rootGetters['builder/fieldRelation/displayableValue'];
  const entities =
    rootGetters['builder/entityCurrent/list'];
  const entity =
    rootGetters['builder/entityCurrent/current'];

  return Object.keys(field.relation).map((key) => {
    return `${label(field, key)}: ${value(
      entities,
      entity,
      field,
      key,
      field.relation[key],
    )}`;
  });
}

function validations(field, rootGetters) {
  if (!field.validations) {
    return [];
  }

  const label =
    rootGetters['builder/fieldValidation/label'];
  const value =
    rootGetters['builder/fieldValidation/displayableValue'];

  return field.validations.map((validation) => {
    return `${label(field, validation.key)}: ${value(
      field,
      validation.key,
      validation.value,
    )}`;
  });
}

export default {
  adaptFieldsForTable(fields, rootGetters) {
    const entity =
      rootGetters['builder/entityCurrent/current'];
    const relationships = RelationshipUtils.selectFromEntity(
      entity,
      rootGetters['builder/relationshipCurrent/list'],
    );

    if (!fields?.length && !relationships?.length) {
      return [];
    }

    let fieldsAndRelationships = [
      ...(fields || []),
      ...(relationships || []),
    ];

    fieldsAndRelationships.sort(
      (a, b) =>
        RelationshipUtils.selectOrder(a, entity) -
        RelationshipUtils.selectOrder(b, entity),
    );

    return fieldsAndRelationships.map((field) => {
      return {
        id: field.id,
        name: fieldName(field, entity),
        type: fieldType(field, entity, rootGetters),
        properties: properties(field, rootGetters),
        relation: relation(field, rootGetters),
        validations: validations(field, rootGetters),
        isRelationship: RelationshipUtils.isRelationship(
          field,
        ),
      };
    });
  },
};
